export default __webpack_public_path__ + "static/media/img5.259ed0c2.png";